var React = require('react');

function SearchInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M97.7 90.5 73.9 66.7c12.4-16 11.3-39.2-3.4-53.9-7.7-7.7-18-12-28.9-12s-21.2 4.3-28.9 12-12 18-12 28.9 4.3 21.2 12 28.9 18 12 28.9 12c9.2 0 17.9-3 25-8.6l23.8 23.8c1 1 2.3 1.5 3.6 1.5 1.3 0 2.6-.5 3.6-1.5 2.1-2.1 2.1-5.3.1-7.3zM20 63.3c-5.8-5.8-9-13.5-9-21.6 0-8.2 3.2-15.9 9-21.6 5.8-5.8 13.5-9 21.6-9 8.2 0 15.9 3.2 21.6 9 11.9 11.9 11.9 31.3 0 43.3-5.8 5.8-13.5 9-21.6 9-8.1-.2-15.8-3.3-21.6-9.1z"}));
}

SearchInline.defaultProps = {"viewBox":"0 0 100 100","style":{"enableBackground":"new 0 0 100 100"},"xmlSpace":"preserve"};

module.exports = SearchInline;

SearchInline.default = SearchInline;
